import React from 'react';

const COPY_BY_KIND = {
  tone: {
    title: 'Revisar tom de voz',
    description: 'Compare o rascunho atual com a sugestão da IA antes de aplicar.',
  },
  instructions: {
    title: 'Revisar instruções',
    description: 'Compare o rascunho atual com a sugestão da IA antes de aplicar.',
  },
  mcp_usage_instructions: {
    title: 'Revisar instruções de uso do MCP',
    description:
      'Compare o rascunho atual com a sugestão da IA antes de aplicar ao binding MCP.',
  },
  prompt_content: {
    title: 'Revisar conteúdo do prompt',
    description: 'Compare o rascunho atual com a sugestão da IA antes de aplicar.',
  },
  inbound_router_instructions: {
    title: 'Revisar instruções de roteamento',
    description:
      'Compare o rascunho atual com a sugestão da IA antes de aplicar ao roteamento.',
  },
  inbound_route_description: {
    title: 'Revisar descrição do destino',
    description:
      'Compare a descrição atual com a sugestão da IA antes de aplicar a este destino.',
  },
};

function PreviewPanel({ label, text }) {
  return (
    <div className="flex flex-col min-h-0">
      <p className="text-xs font-medium text-content-muted mb-2">{label}</p>
      <div className="flex-1 rounded-xl border border-surface-border bg-slate-50 p-3 overflow-auto max-h-64 sm:max-h-80">
        <pre className="text-sm text-content-primary whitespace-pre-wrap font-sans">{text}</pre>
      </div>
    </div>
  );
}

function ImprovePreviewModal({
  open,
  kind,
  previousText,
  improvedText,
  isApplying,
  error,
  onDiscard,
  onBackToConsiderations,
  onApply,
}) {
  const copy = COPY_BY_KIND[kind] || COPY_BY_KIND.tone;

  if (!open) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <button
        type="button"
        aria-label="Fechar modal"
        className="absolute inset-0 bg-slate-900/40 backdrop-blur-[1px]"
        onClick={isApplying ? undefined : onDiscard}
        disabled={isApplying}
        tabIndex={isApplying ? -1 : 0}
      />
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="improve-preview-title"
        className="relative w-full max-w-4xl surface-card shadow-card-md p-6"
      >
        <h2 id="improve-preview-title" className="text-lg font-semibold text-content-primary">
          {copy.title}
        </h2>
        <p className="text-sm text-content-muted mt-1 mb-5">{copy.description}</p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <PreviewPanel label="Antes" text={previousText} />
          <PreviewPanel label="Depois (sugestão da IA)" text={improvedText} />
        </div>

        {error && <p className="mt-4 text-sm text-red-600">{error}</p>}

        <div className="flex flex-col sm:flex-row gap-3 mt-6">
          <button
            type="button"
            onClick={onDiscard}
            disabled={isApplying}
            className="btn-secondary flex-1"
          >
            Descartar
          </button>
          <button
            type="button"
            onClick={onBackToConsiderations}
            disabled={isApplying}
            className="btn-secondary flex-1"
          >
            Ajustar considerações
          </button>
          <button
            type="button"
            onClick={onApply}
            disabled={isApplying}
            className="btn-primary flex-1"
          >
            {isApplying ? 'Aplicando...' : 'Aplicar melhoria'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ImprovePreviewModal;
